import AddWidgetContainer from './AddWidget.container';
import AddWidget, { Props as ImportedProps } from './AddWidget';
export default AddWidgetContainer(AddWidget);
export type Props = ImportedProps;
